// @ts-nocheck
import React, { createRef } from "react";
import BaseShare from "../baseShare";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../sections/taskInfoSections";
import ProcedureInformation from "../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import Buttons from "../../../../base/basicComponents/button";
import NormalToolTip from "../../../../base/basicComponents/toolTip";
import { ModalWithComponent } from "../../../../base/basicComponents/modal";
import InputLabel from "../../../../base/basicComponents/inputLabel";
import redTipIcon from "../../../../assets/image/redTipIcon.png";
import { actions } from "../../../publicDictionaryValues";
import approveShareService from "../../../../service/shareTask/approveShareService";
import ApproveShareTask from "../../../sections/sharedTaskSections/approveShareTask/index";
import NormalModel from "../../../../base/basicComponents//modal/index";
import styles from "../../procedureFileProcess/style/index.module.scss";
import appService from "../../../../service/app";
import LostPermissionModal from "../../../sections/lostPermissionModal";
import "../index.scss";
import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import StepService from "../../../../service/stepBase/StepService";
import { disableInteraction } from "utils";

const procedureFileRef = createRef();
const approveShareTaskRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();

export default class ApproveShareTaskProcess extends BaseShare {
  constructor(props: any) {
    super(props);
    this.state = {
      pageState: this.handleApproveShareTaskPageState(),
      modalState: this.handleApproveShareTaskModalState(),
      returnOrRejectModalTitle: "",
      isReturnOrRejectModalOpen: false,
      isApproveComfirmOpen: false,
      confirmModalText: "",
      handleApproveComfirm: () => {
        //this is a empty function
      },
      returnOrRejectInputStatus: "",
      returnOrRejectInputValue: "",
      noPermission: false,
    };
    // @ts-ignore
    this.para = null;
    // @ts-ignore
    this.modalContentLabels = this.handleApproveShareTaskModalContentLabels();
    // @ts-ignore
    this.params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };
  }

  handleApproveShareTaskPageState = () => {
    const { rejectReason, rejectStatus } = this.props.pageProps;

    return {
      rejectReason,
      rejectStatus,
      isCancelDisabled: false,
      isSubmitDisabled: this.checkSubmitDisable(this.props.shareTaskData),
      isRejectDisabled: false,
      isTableBorderError: false,
    };
  };

  handleApproveShareTaskModalState = () => {
    return {
      modalTitle: "",
      modalLabel: "",
      okText: "",
      cancelText: "",
      actionType: "",
      uploadDraggerFileType: "",
      rowIndex: 0,
      fileIds: [],
      fileNames: [],
      modalWidth: 520,
      closable: false,
      isOkBtnDisabled: false,
      isCancelBtnDisabled: false,
      maskClosable: false,
      isModalWithComponentOpen: false,
      isShowTextArea: false,
      textAreaPlacement: "",
      textAreaMaxLength: 0,
      textAreaClassName: "",
      isShowSelect: false,
      isShowTextAreaAndUploadDragger: false,
    };
  };

  handleApproveShareTaskModalContentLabels = () => {
    return {
      submitConfirmModalLabel: <span className={styles.modalText}>Are you sure to submit?</span>,
      cancelConfimModalLabel: (
        <span className={styles.modalText}>Are you sure to quit without saving?</span>
      ),
      rejectModalWarningLabel: (
        <>
          <div className={styles.rejectModalWarning}>
            Are you sure to reject this request? Reject means that the process will be terminated.
            The status will be changed back to the original status before this initiation.
          </div>
          <InputLabel text="Reject Reason" required={true} />
        </>
      ),
    };
  };

  handleControlErrorScroll = (top: any) => window.scrollTo(0, top || 0);

  /* function about click submit button in revise page if server path doesn't enter required field*/
  handleCheckServerPathHighLight = () => {
    this.props.procedureServerPathRef.current.setServerPathError();
    this.props.procedureServerPathRef.current !== null &&
      this.handleControlErrorScroll(this.props.procedureServerPathRef.current.offsetTop);
  };

  handleApproveConfirm = () => {
    this.props._showLoading();
    this.setState({
      isApproveComfirmOpen: false,
    });
    const para = this.handleSubmitPara(actions.approve, "Approve", approveShareTaskRef);
    approveShareService.manageShareTaskTriggerAction(para, this.approveSuccess, this.approveFailed);
  };

  checkUploadSignOff = () => {
    const para = this.getCheckUploadSignOffPara(approveShareTaskRef);
    approveShareService.checkHasPendingSignOff(
      para,
      this.checkHasPendingSignOffSuccess,
      this.checkHasPendingSignOffFail
    );
  };

  _checkStepPermissionSuccess = (result: any, actionType: any) => {
    this.props._hideLoading();
    const { statusCode } = result;
    const noPermission = statusCode !== 200;
    this.setState({
      noPermission,
    });
    if (noPermission) return;
    if (actionType === "approve") {
      this.handleApproveShareTaskSubmitClick();
    } else if (actionType === "reject") {
      this.handleApproveShareTaskRejectClick();
    } else if (actionType === "return") {
      this.handleApproveShareTaskReturnClick();
    }
  };

  checkStepPermission = (actionType: any) => {
    this.props._showLoading();
    const param = {
      taskID: this.props.params.ProcedureTaskId,
      procedureID: this.props.params.ProcedureID,
      procedureStepID: this.props.params.ProcedureStepID,
      parentPage: null,
    };
    appService.checkStepPermission(
      param,
      (response: any) => this._checkStepPermissionSuccess(response, actionType),
      (response: any) => this._alertError(response.message)
    );
  };

  handleApproveShareTaskSubmitClick = () => {
    disableInteraction();
    this.checkApprove(approveShareTaskRef, approveShareService.checkApprove);
  };

  handleApproveShareTaskRejectClick = () => {
    this.setState({
      modalState: {
        ...this.state.modalState,
        isModalWithComponentOpen: true,
        modalTitle: <span className="fs-18">Reject</span>,
        isShowTextArea: true,
        // @ts-ignore
        modalLabel: this.modalContentLabels.rejectModalWarningLabel,
        textAreaMaxLength: 1000,
        textAreaClassName: styles.rejectReasonInput,
        okText: "Confirm",
        cancelText: "Cancel",
        actionType: "reject",
        modalWidth: 520,
        handleCancel: this.handleApproveShareRejectCancelClick,
        handleOk: () =>
          this.handleApproveShareRejectOkClick(
            approveShareService.manageShareTaskTriggerAction,
            approveShareTaskRef
          ),
      },
    });
  };

  handleApproveShareTaskSetRejectValue = (e: any) => {
    this.setState({
      pageState: {
        ...this.state.pageState,
        rejectReason: e.target.value,
        rejectStatus: null,
      },
    });
  };

  handleApproveShareTaskReturnClick = () => {
    this.setState({
      returnOrRejectModalTitle: "Reason for Return",
      isReturnOrRejectModalOpen: true,
    });
  };

  handleApproveShareTaskApproveComfirmCancel = () => {
    this.setState({
      isApproveComfirmOpen: false,
    });
  };

  handleApproveShareTaskApprovalCancel = () => {
    this.setState({
      isApproveComfirmOpen: true,
      confirmModalText: "Are you sure to quit without saving?",
      handleApproveComfirm: this.props.closePage,
    });
  };

  approveShareTaskreturnOrRejectInputOnChange = (e: any) => {
    this.setState({
      returnOrRejectInputValue: e.value,
      returnOrRejectInputStatus: "",
    });
  };

  handleApproveShareTaskReturnOrRejectCancel = () => {
    this.setState({
      returnOrRejectModalTitle: "",
      isReturnOrRejectModalOpen: false,
      returnOrRejectInputStatus: "",
      returnOrRejectInputValue: "",
    });
  };

  approveShareTaskreturnSuccess = () => {
    this.props._hideLoading();
    this._alertSuccess("Return Successful");
    this.props.closePage();
  };

  approveShareTaskreturnFailed = () => {
    this.props._hideLoading();
    this._alertError("Return Failed");
  };

  handleApproveShareTaskReturnOrRejectOk = () => {
    if (this.state.returnOrRejectInputValue.trim() === "") {
      this.setState({
        returnOrRejectInputStatus: "error",
      });
    } else {
      this.props._showLoading();
      this.setState({
        isReturnOrRejectModalOpen: false,
      });
      const para = this.handleSubmitPara(actions.return, "Return", approveShareTaskRef);
      approveShareService.manageShareTaskTriggerAction(
        para,
        this.approveShareTaskreturnSuccess,
        this.approveShareTaskreturnFailed
      );
    }
  };

  checkSubmitDisable = (data: any) => {
    if (data === undefined || data === null || Object.keys(data).length === 0) {
      return true;
    }

    const deleteIndex = data.shareTasks.findIndex(
      (x: any) => x.isDel !== undefined && x.isDel === true
    );
    const newIndex = data.shareTasks.findIndex(
      (x: any) => x.isNew !== undefined && x.isNew === true
    );

    if (deleteIndex > -1 || newIndex > -1) {
      return false;
    }

    return true;
  };

  approveShareTaskComponentDidUpdate = (prevProps: any) => {
    if (prevProps.shareTaskData !== this.props.shareTaskData) {
      if (this.checkSubmitDisable(this.props.shareTaskData)) {
        this.setState({
          pageState: {
            ...this.state.pageState,
            isSubmitDisabled: true,
          },
        });
      } else {
        this.setState({
          pageState: {
            ...this.state.pageState,
            isSubmitDisabled: false,
          },
        });
      }
    }
  };

  componentDidUpdate(prevProps: any) {
    this.approveShareTaskComponentDidUpdate(prevProps);
  }

  handleApproveShareTaskPageHeader = () => {
    const { receiveDate, requestByName, procedureStepStatus } = this.props.pageProps;

    return (
      <PageHeader
        title="Approve Shared Tasks"
        receiveDate={this._formateDate(receiveDate)}
        requestBy={requestByName}
        status={procedureStepStatus}
      />
    );
  };

  handleApproveShareTaskTaskInformation = () => {
    const { taskInfoData } = this.props.sectionProps;

    return (
      <ProcedureBlock
        testid="task-info-block-arrow"
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInfoData} />}
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setTaskInfoData,
            this.setError,
            [StepBusinessType.taskInfo],
            StepService.getMergePayloadBySettingKey([StepBusinessType.taskInfo.settingKey])
          );
        }}
      />
    );
  };

  handleApproveShareTaskProcedureFileSection = () => {
    const { serverPathValue, savedInRadioValue, fileTableData, jbProcedureSavedIn } = this.props;

    return (
      <ProcedureBlock
        testid="procedure-file-block-arrow"
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlyProcedureFileSection
            procedureFileRef={procedureFileRef}
            clientServerPath={serverPathValue}
            savedInRadioValue={savedInRadioValue}
            procedureFileData={fileTableData !== undefined ? fileTableData : []}
            jbProcedureSavedIn={jbProcedureSavedIn}
          />
        }
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureFileData,
            this.setError,
            [StepBusinessType.procedureFile]
          );
        }}
      />
    );
  };

  handleApproveShareTaskSupportingFileSection = () => {
    const { supportingTableData } = this.props;

    return (
      <ProcedureBlock
        testid="supporting-file-block-arrow"
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlySupportingFileSection
            supportingFileRef={supportingFileRef}
            supportingFileTableRef={supportingFileTableRef}
            supportingFileData={supportingTableData}
          />
        }
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setSupportingFileData,
            this.setError,
            [StepBusinessType.supportingFile]
          );
        }}
      />
    );
  };

  handleApproveShareTaskProcedureInfoSection = () => {
    const { procedureStatus } = this.props.pageProps;
    const { procedureInfoData, ppoList } = this.props.sectionProps;

    return (
      <ProcedureBlock
        testid="procedure-info-block-arrow"
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            ppoList={ppoList}
            isShowActions={false}
            noteDisabled={true}
            procedureStatus={procedureStatus}
            title="Procedure Information"
            submitData={procedureInfoData}
            isPPODisabled={true}
          />
        }
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureInfoData,
            this.setError,
            [
              StepBusinessType.procedureOwner,
              StepBusinessType.pmpExcluded,
              StepBusinessType.primaryProcedureOwner,
            ]
          );
        }}
      />
    );
  };

  handleApproveShareTaskSection = () => {
    const { shareTaskData } = this.props;

    return (
      <ProcedureBlock
        testid="approve-share-task-block-arrow"
        className={styles.approveProcedureFile}
        child={
          // @ts-ignore
          <ApproveShareTask shareTaskData={shareTaskData} ref={approveShareTaskRef} />
        }
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  handleApproveShareTaskButton = () => {
    const { isSubmitDisabled, isRejectDisabled } = this.state.pageState;

    return (
      <div className={styles.actionBtns}>
        <div className={styles.normalBtns}>
          <Buttons
            testid="share-task-return-btn"
            color="grey"
            size="middle"
            onClick={() => this.checkStepPermission("return")}
            disabled={false}
            btnClassName={styles.approveActionBtn}
          >
            Return to Revise
          </Buttons>
          <Buttons
            testid="share-task-cancel-btn"
            color="grey"
            size="middle"
            onClick={this.handleApproveShareTaskApprovalCancel}
            disabled={false}
            btnClassName={styles.approveActionBtn}
          >
            Cancel
          </Buttons>
          <Buttons
            testid="share-task-approve-btn"
            color="blue"
            size="middle"
            onClick={() => this.checkStepPermission("approve")}
            disabled={isSubmitDisabled}
            btnClassName={styles.approveActionBtn}
          >
            Approve
          </Buttons>
        </div>
        <div className={styles.rejectBtn}>
          <Buttons
            testid="share-task-reject-btn"
            color="red"
            size="middle"
            onClick={() => this.checkStepPermission("reject")}
            disabled={isRejectDisabled}
          >
            Reject
          </Buttons>
          <NormalToolTip
            element={
              <div className={styles.rejectTipIcon}>
                <img src={redTipIcon} alt="Reject" />
              </div>
            }
            title="Reject means that the process will be terminated. The status will be changed back to the original status before this initiation."
            color="#FF5858"
            overlayClassName={styles.rejectTip}
          />
        </div>
      </div>
    );
  };

  handleApproveShareTaskRejectModalWithComponent = () => {
    const {
      textAreaPlacement,
      textAreaMaxLength,
      textAreaClassName,
      modalTitle,
      modalLabel,
      isOkBtnDisabled,
      isCancelBtnDisabled,
      isModalWithComponentOpen,
      isShowTextArea,
      modalWidth,
      handleOk,
      handleCancel,
      cancelText,
      closable,
      okText,
    } = this.state.modalState;
    const { rejectReason, rejectStatus } = this.state.pageState;

    return (
      <ModalWithComponent
        testid="share-task-reject-modal"
        isModalOpen={isModalWithComponentOpen}
        closable={closable}
        okText={okText}
        cancelText={cancelText}
        label={modalLabel}
        modalWidth={modalWidth}
        isOkDisabled={isOkBtnDisabled}
        isCancelDisabled={isCancelBtnDisabled}
        isShowTextArea={isShowTextArea}
        textAreaMaxLength={textAreaMaxLength}
        textAreaStatus={rejectStatus}
        textAreaClassName={textAreaClassName}
        textAreaValue={rejectReason}
        textAreaOnChange={this.handleApproveShareTaskSetRejectValue}
        textAreaPlacement={textAreaPlacement}
        title={modalTitle}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    );
  };

  handleApproveShareTaskReturnModalWithComponent = () => {
    return (
      <ModalWithComponent
        testid="share-task-return-modal"
        title={this.state.returnOrRejectModalTitle}
        label={
          <InputLabel
            text="Please enter Return Reason"
            required={true}
            className={styles.modalText}
          />
        }
        isModalOpen={this.state.isReturnOrRejectModalOpen}
        okText="Confirm"
        cancelText="Cancel"
        handleOk={this.handleApproveShareTaskReturnOrRejectOk}
        handleCancel={this.handleApproveShareTaskReturnOrRejectCancel}
        closable={false}
        isShowTextArea={true}
        textAreaValue={this.state.returnOrRejectInputValue}
        textAreaOnChange={(e: any) => this.approveShareTaskreturnOrRejectInputOnChange(e.target)}
        textAreaMaxLength={1000}
        textAreaStatus={this.state.returnOrRejectInputStatus}
      />
    );
  };

  handleApproveShareTaskNomalComponent = () => {
    return (
      <NormalModel
        testid="share-task-confirm-modal"
        okText="Confirm"
        cancelText="Cancel"
        childContent={<p className="fs-16">{this.state.confirmModalText}</p>}
        isModalOpen={this.state.isApproveComfirmOpen}
        handleOk={this.state.handleApproveComfirm}
        handleCancel={this.handleApproveShareTaskApproveComfirmCancel}
      />
    );
  };

  render() {
    const { procedureStepStatus, actionID } = this.props.pageProps;
    const { rejectReason } = this.state.pageState;

    return (
      <div className={styles.approveNewPro}>
        {this.handleApproveShareTaskPageHeader()}
        {this.handleApproveShareTaskTaskInformation()}
        {this.handleApproveShareTaskProcedureFileSection()}
        {this.handleApproveShareTaskSupportingFileSection()}
        {this.handleApproveShareTaskProcedureInfoSection()}
        {this.handleApproveShareTaskSection()}
        {procedureStepStatus === "Pending" && this.handleApproveShareTaskButton()}
        {this.handleApproveShareTaskRejectModalWithComponent()}
        {actionID === actions.reject && rejectReason !== null && (
          <div className={styles.rejectReasonBlock}>
            <span className={styles.rejectReasonTip}>Reject Reason</span>
            <p className={styles.rejectReasonContent}>{rejectReason}</p>
          </div>
        )}
        {this.handleApproveShareTaskReturnModalWithComponent()}
        {this.handleApproveShareTaskNomalComponent()}
        <LostPermissionModal isModalOpen={this.state.noPermission} />
      </div>
    );
  }
}
